import CopyIcon from '@mui/icons-material/ContentCopy'
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { ChangeEvent, FC, useEffect, useState } from 'react'
import { UserType } from '../../api/appAPI'
import { copyTextToClipboard, encryptAES } from '../../common/helpers'
import {
  EnqueueSnackbarType,
  Flex,
  UploadButton,
} from '../../components/common/Helpers'
import OfferMarkup from '../../components/common/OfferMarkup'

interface ICustomerStatusesProps {
  customerStatuses: string[]

  setCustomerStatuses(arr: string[]): void
}

const CustomerStatuses: FC<ICustomerStatusesProps> = ({
  customerStatuses,
  setCustomerStatuses,
}) => {
  const [newStatusValue, setNewStatusValue] = useState('')

  const addNewStatus = (e: any) => {
    if (!customerStatuses.includes(newStatusValue) && newStatusValue !== '') {
      setCustomerStatuses([...customerStatuses, newStatusValue])
      setNewStatusValue('')
    }
  }

  return (
    <Flex
      column
      centerX
      sx={{ mt: 2, pt: 2, borderTop: '1px solid', borderTopColor: 'divider' }}
    >
      <Typography>Customer Statuses</Typography>
      <Box
        component="ul"
        px={1}
        my={2}
        style={{
          display: 'flex',
          justifyContent: 'center',
          columnGap: 10,
          rowGap: 10,
          flexWrap: 'wrap',
          listStyle: 'none',
        }}
      >
        {customerStatuses.map((status) => (
          <li key={status}>
            <Chip
              label={status}
              onDelete={() => {
                setCustomerStatuses(
                  customerStatuses.filter((v) => v !== status)
                )
              }}
              // color={status === props.defaultValue ? 'primary' : undefined}
              // onClick={() => {
              //     props.setDefaultValue(status)
              // }}
            />
          </li>
        ))}
      </Box>

      <FormControl variant="outlined" fullWidth>
        <InputLabel>Enter New Status</InputLabel>
        <OutlinedInput
          // style={{ width: props.width }}
          label="Enter New Status"
          value={newStatusValue}
          onChange={(e) => setNewStatusValue(e.target.value)}
          // onBlur={handleNewStatusBlur}
          onKeyUp={(e) => {
            if (e.key === 'Enter') addNewStatus(e)
          }}
          onFocus={(e) => e.target.select()}
          endAdornment={
            newStatusValue ? (
              <Button variant="contained" onClick={addNewStatus}>
                Add
              </Button>
            ) : (
              <></>
            )
          }
        />
      </FormControl>
    </Flex>
  )
}

type DiscountOptionsType = {
  total: number
  totalType: number // 0->% 1->$
  cabinet: number
  slatwall: number
  slatwallAcc: number
  overhead: number
  garageShop: number
  floorCoating: number
  discountMode: number //0->total 1->individual
  showInCart: boolean
}

interface IDiscountOptionsProps {
  companyOptions: Object

  saveDiscountOptions(opt: DiscountOptionsType): void
  close(): void
}

const DiscountOptions: FC<IDiscountOptionsProps> = ({
  companyOptions,
  ...props
}) => {
  const [discountOptions, setDiscountOptions] = useState<DiscountOptionsType>({
    total: 0,
    totalType: 0, // 0->% 1->$
    cabinet: 0,
    slatwall: 0,
    slatwallAcc: 0,
    overhead: 0,
    garageShop: 0,
    floorCoating: 0,
    discountMode: 0, //0->total 1->individual
    showInCart: true,
    // @ts-ignore
    ...(companyOptions.discount || {}),
  })

  return (
    <>
      {' '}
      <DialogTitle>Default Discounts</DialogTitle>
      <DialogContent dividers>
        <Flex column sx={{ gap: 2 }}>
          <Flex>
            <FormControl variant="outlined" style={{ flexGrow: 1 }}>
              <InputLabel>Total Order Discount</InputLabel>
              <OutlinedInput
                label="Total Order Discount"
                startAdornment={
                  <InputAdornment position="start">
                    {discountOptions.totalType === 0 ? '%' : '$'}
                  </InputAdornment>
                }
                // endAdornment={<Flex centerY>
                //     <Typography>%</Typography>
                //     <Switch
                //         checked={discountOptions.totalType === 1}
                //         onChange={e => {
                //             setDiscountOptions({
                //                 ...discountOptions,
                //                 totalType: e.target.checked ? 1 : 0
                //             })
                //         }}
                //     />
                //     <Typography>$</Typography>
                // </Flex>}
                type="number"
                value={discountOptions.total}
                onChange={(e) => {
                  setDiscountOptions({
                    ...discountOptions,
                    total: parseFloat(e.target.value),
                    totalType: 0,
                  })
                }}
              />
            </FormControl>
          </Flex>
          <Divider sx={{ mb: 2 }} />

          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Cabinet/Countertops</InputLabel>
            <OutlinedInput
              label="Cabinet/Countertops"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.cabinet}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  cabinet: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>
          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Slatwall</InputLabel>
            <OutlinedInput
              label="Slatwall"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.slatwall}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  slatwall: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>
          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Slatwall Accessories</InputLabel>
            <OutlinedInput
              label="Slatwall Accessories"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.slatwallAcc}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  slatwallAcc: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>
          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Overhead Storage</InputLabel>
            <OutlinedInput
              label="Overhead Storage"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.overhead}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  overhead: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>
          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Garage Shop</InputLabel>
            <OutlinedInput
              label="Garage Shop"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.garageShop}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  garageShop: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>

          <FormControl variant="outlined" style={{ flexGrow: 1 }}>
            <InputLabel>Floor Coating</InputLabel>
            <OutlinedInput
              label="Floor Coating"
              startAdornment={
                <InputAdornment position="start">%</InputAdornment>
              }
              type="number"
              value={discountOptions.floorCoating}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  floorCoating: parseFloat(e.target.value),
                })
              }}
            />
          </FormControl>

          <Divider />

          <Flex centerY>
            <Typography>Total Discount</Typography>
            <Switch
              checked={discountOptions.discountMode === 1}
              onChange={(e) => {
                setDiscountOptions({
                  ...discountOptions,
                  discountMode: e.target.checked ? 1 : 0,
                })
              }}
            />
            <Typography>Individual Discount</Typography>
          </Flex>

          <FormControlLabel
            label="Show Discount in Cart"
            control={
              <Checkbox
                checked={discountOptions.showInCart}
                onChange={(e) => {
                  setDiscountOptions({
                    ...discountOptions,
                    showInCart: e.target.checked,
                  })
                }}
              />
            }
          />
        </Flex>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={props.close}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => props.saveDiscountOptions(discountOptions)}
        >
          Save
        </Button>
      </DialogActions>
    </>
  )
}

interface IProps {
  user: UserType

  editUser(user: UserType, enqueueSnackbar: EnqueueSnackbarType): void
}

const Settings: FC<IProps> = (props) => {
  const [email, setEmail] = useState(props.user?.email || '')
  const [name, setName] = useState(props.user?.name || '')
  const [lastName, setLastName] = useState(props.user?.lastName || '')
  const [phone, setPhone] = useState(props.user?.phone || '')
  const [companyName, setCompanyName] = useState(props.user?.companyName || '')
  const [offerMarkups, setOfferMarkups] = useState(
    (() => {
      if (props.user) {
        if (props.user.offerMarkups.length < 14) {
          const needZeros = 14 - props.user.offerMarkups.length

          const zeros = []

          for (let i = 0; i < needZeros; i++) {
            zeros.push(0)
          }

          return [...props.user.offerMarkups, ...zeros]
        }

        return props.user.offerMarkups
      } else {
        return []
      }
    })()
  )
  const [isDiscountDialogOpen, setIsDiscountDialogOpen] = useState(false)

  const [logo, setLogo] = useState<string>(props.user?.companyLogo || '')

  const [companyOptions, setCompanyOptions] = useState<Object>({})
  const [customerStatuses, setCustomerStatuses] = useState<string[]>([])

  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (props.user) {
      setEmail(props.user.email)
      setName(props.user.name)
      setCompanyName(props.user.companyName)
      setOfferMarkups(
        (() => {
          if (props.user.offerMarkups.length < 14) {
            const needZeros = 14 - props.user.offerMarkups.length

            const zeros = []

            for (let i = 0; i < needZeros; i++) {
              zeros.push(0)
            }

            return [...props.user.offerMarkups, ...zeros]
          }

          return props.user.offerMarkups
        })()
      )
      setLogo(props.user.companyLogo)

      if (props.user.role === 'company') {
        try {
          const options = JSON.parse(props.user.options) || {}

          setCompanyOptions(options)
          setCustomerStatuses(
            options.customerStatuses ? options.customerStatuses.split(';') : []
          )
        } catch (error) {
          alert('Not valid options string ' + props.user.options)
        }
      }
    }
  }, [props.user])

  const handleSubmit = () => {
    // @ts-ignore
    companyOptions.customerStatuses = customerStatuses.join(';')

    props.editUser(
      {
        ...props.user,
        name,
        lastName,
        phone,
        companyName,
        offerMarkups,
        companyLogo: logo,
        options: JSON.stringify(companyOptions),
      },
      enqueueSnackbar
    )
  }

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      var file = e.target.files[0]
      var reader = new FileReader()
      reader.onload = (e) => {
        const img: any = document.createElement('img')

        img.onload = () => {
          const canvas: any = document.createElement('canvas')
          let ctx = canvas.getContext('2d')

          ctx.drawImage(img, 0, 0)

          const MAX_SIZE = 1024
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_SIZE) {
              height *= MAX_SIZE / width
              width = MAX_SIZE
            }
          } else {
            if (height > MAX_SIZE) {
              width *= MAX_SIZE / height
              height = MAX_SIZE
            }
          }

          canvas.width = width
          canvas.height = height
          ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)

          const dataUrl = canvas.toDataURL()
          setLogo(dataUrl)
        }

        img.src = e.target?.result
      }
      reader.readAsDataURL(file)
    }
  }

  const saveDiscountOptions = (discountOptions: DiscountOptionsType) => {
    // @ts-ignore
    companyOptions.discount = discountOptions

    props.editUser(
      {
        ...props.user,
        options: JSON.stringify(companyOptions),
      },
      enqueueSnackbar
    )

    setIsDiscountDialogOpen(false)
  }

  const invitationLink =
    window.location.href.split('//')[1].split('/profile')[0] +
    '/?dir=signup/' +
    encryptAES(props.user?.email || '')

  return (
    <Flex centerX>
      <Paper elevation={5} sx={{ mt: 2, p: 3 }}>
        <Flex sx={{ gap: 5 }}>
          <Flex
            column
            centerX
            sx={{ width: props.user.role === 'company' ? 0.33 : 1 }}
          >
            <TextField
              label="Email"
              variant="outlined"
              value={email}
              disabled
              style={{ width: '100%', marginTop: 15, maxWidth: 300 }}
            />
            <TextField
              label="First Name"
              variant="outlined"
              value={name}
              onChange={(e) => {
                setName(e.target.value)
              }}
              style={{ width: '100%', marginTop: 15, maxWidth: 300 }}
            />
            <TextField
              label="Last Name"
              variant="outlined"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value)
              }}
              style={{ width: '100%', marginTop: 15, maxWidth: 300 }}
            />
            <TextField
              label="Phone"
              type="number"
              variant="outlined"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value)
              }}
              style={{ width: '100%', marginTop: 15, maxWidth: 300 }}
            />
          </Flex>
          {props.user.role === 'company' ? (
            <>
              <Divider orientation="vertical" sx={{ height: 'inherit' }} />

              <Box sx={{ width: 0.33 }}>
                <Box
                  mt={2}
                  display="flex"
                  justifyContent="space-around"
                  alignItems="center"
                >
                  <img src={logo?.toString()} alt="Logo Preview" width={100} />
                  <UploadButton
                    buttonText="Upload Logo"
                    onFileChange={onFileChange}
                  />
                </Box>
                <TextField
                  label="Company Name"
                  variant="outlined"
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.target.value)
                  }}
                  style={{ width: '100%', marginTop: 15 }}
                />
                <FormControl
                  variant="outlined"
                  style={{ width: '100%', marginTop: 15 }}
                >
                  <InputLabel>Invitation Link</InputLabel>
                  <OutlinedInput
                    label="Invitation Link"
                    value={invitationLink}
                    onFocus={(e) => e.target.select()}
                    endAdornment={
                      <InputAdornment position="end">
                        <Tooltip title="Copy Link" placement="top">
                          <IconButton
                            onClick={() => {
                              copyTextToClipboard(
                                invitationLink,
                                enqueueSnackbar
                              )
                            }}
                            edge="end"
                          >
                            <CopyIcon />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <CustomerStatuses
                  customerStatuses={customerStatuses}
                  setCustomerStatuses={setCustomerStatuses}
                />
              </Box>

              <Divider orientation="vertical" sx={{ height: 'inherit' }} />

              <Box sx={{ width: 0.33 }}>
                <OfferMarkup
                  role={props.user.role}
                  title="Cabinet Markup"
                  firstValue={offerMarkups[0] || 0}
                  secondValue={offerMarkups[1] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 0 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 1 ? newValue : v))
                    )
                  }
                />

                <OfferMarkup
                  role={props.user.role}
                  title="Slatwall Markup"
                  firstValue={offerMarkups[2] || 0}
                  secondValue={offerMarkups[3] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 2 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 3 ? newValue : v))
                    )
                  }
                />

                <OfferMarkup
                  role={props.user.role}
                  title="Slatwall Accessories Markup"
                  firstValue={offerMarkups[4] || 0}
                  secondValue={offerMarkups[5] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 4 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 5 ? newValue : v))
                    )
                  }
                />

                <OfferMarkup
                  role={props.user.role}
                  title="Overhead Storage Markup"
                  firstValue={offerMarkups[6] || 0}
                  secondValue={offerMarkups[7] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 6 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 7 ? newValue : v))
                    )
                  }
                />

                <OfferMarkup
                  role={props.user.role}
                  title="Counter top Markup"
                  firstValue={offerMarkups[8] || 0}
                  secondValue={offerMarkups[9] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 8 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 9 ? newValue : v))
                    )
                  }
                />
                <OfferMarkup
                  role={props.user.role}
                  title="Garage Shop Markup"
                  firstValue={offerMarkups[10] || 0}
                  secondValue={offerMarkups[11] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 10 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 11 ? newValue : v))
                    )
                  }
                />
                <OfferMarkup
                  role={props.user.role}
                  title="Floor Coating Markup"
                  firstValue={offerMarkups[12] || 0}
                  secondValue={offerMarkups[13] || 0}
                  firstOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 12 ? newValue : v))
                    )
                  }
                  secondOnChange={(newValue) =>
                    setOfferMarkups(
                      offerMarkups.map((v, i) => (i === 13 ? newValue : v))
                    )
                  }
                />
                <Flex sx={{ mt: 2 }} centerX>
                  <Button
                    variant="contained"
                    onClick={() => setIsDiscountDialogOpen(true)}
                  >
                    default discounts
                  </Button>
                </Flex>
              </Box>
            </>
          ) : (
            <></>
          )}
        </Flex>
        <Flex
          centerX
          sx={{ mt: 2, borderTop: '1px solid', borderTopColor: 'divider' }}
        >
          <Button
            style={{ marginTop: 15 }}
            size="medium"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Flex>
      </Paper>
      <Dialog
        open={isDiscountDialogOpen}
        onClose={() => setIsDiscountDialogOpen(false)}
      >
        <DiscountOptions
          companyOptions={companyOptions}
          saveDiscountOptions={saveDiscountOptions}
          close={() => setIsDiscountDialogOpen(false)}
        />
      </Dialog>
    </Flex>
  )
}

export default Settings
